import {Message} from "./message";
import {MessageDelay} from "./message_delay";
import {MessageReceiver} from "./message_receiver";

export class RoleStatusMessage {
  public id: string;
  public additionalInfo: string;
  public messageId: string;
  public message: Message;
  public receivers: MessageReceiver[] = [];
  public delays: MessageDelay[] = [];
}
